import React from 'react';

import {ARCHIVED_ANALYSIS_TOOLTIP_TEXT} from 'analysis-tool/AnalysisToolConstants';
import {useIsConsolidatedAddSourceEnabled} from 'analysis-tool/AnalysisToolFeatureGates';
import {
  getAddDataFrameAnalysisViewItem,
  getEnabledDatasetCreationMethods,
  trackSelectedDataFrameCreationMethodEvent,
} from 'analysis-tool/data-frame-creation/DataFrameCreationUtils';
import {
  AnalysisRightSidebarItem,
  AnalysisRightSidebarItemType,
} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import isArchived from 'archive/isArchived';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {AnalysisMainViewItem} from './main-view/MainViewTypes';

export interface AddDataButtonProps {
  actionOrigin: Parameters<typeof trackSelectedDataFrameCreationMethodEvent>[0];
  analysis: PipelineGraphQL;
  buttonSize: ButtonSize;
  onOpenStepInitializationView: (newSelectedItem: AnalysisMainViewItem) => void;
  onOpenRightSidebarItem?: (newSelectedRightSidebarItem: AnalysisRightSidebarItem | null) => void;
}
export default function AddDataButton({
  actionOrigin,
  analysis,
  buttonSize,
  onOpenStepInitializationView,
  onOpenRightSidebarItem,
}: AddDataButtonProps): JSX.Element {
  const consolidatedAddSourceEnabled = useIsConsolidatedAddSourceEnabled();
  const dataFrameCreationMethods = getEnabledDatasetCreationMethods();
  const isDisabled = isArchived(analysis);

  return (
    <Tooltip text={isArchived(analysis) ? ARCHIVED_ANALYSIS_TOOLTIP_TEXT : null}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        icon="plus-large"
        size={buttonSize}
        text="Add data"
        disabled={isDisabled}
        onClick={() => {
          if (consolidatedAddSourceEnabled && onOpenRightSidebarItem != null) {
            onOpenRightSidebarItem({type: AnalysisRightSidebarItemType.ADD_SOURCE_STEP});
          } else {
            onOpenStepInitializationView(getAddDataFrameAnalysisViewItem());
            if (dataFrameCreationMethods.length === 1) {
              trackSelectedDataFrameCreationMethodEvent(
                actionOrigin,
                analysis.id,
                dataFrameCreationMethods.length,
                dataFrameCreationMethods[0]
              );
            }
          }
        }}
      />
    </Tooltip>
  );
}
